import { getCurrentRoute } from '../../routeInfo';

function getUrlInfo(pathname?: string) {
    let url = getCurrentRoute(pathname);

    const urlParts = url.split('/');

    let projectName;
    let scriptName;
    let conversationName;
    let isTestMode = false;
    let isEditScriptMode = false;
    let page = null;
    const routeGroup = urlParts[2];

    if (['projects'].includes(urlParts[0])) {
        if (urlParts[1]) {
            projectName = decodeURIComponent(urlParts[1]);
            isEditScriptMode = true;
            page = 'project';
        }
        if (['embed', 'analytics', 'diff'].includes(routeGroup)) {
            if (routeGroup === 'analytics') {
                page = 'analytics';
                isEditScriptMode = false;
                scriptName = urlParts[3];
            }

            if (routeGroup === 'embed') {
                page = 'embed';
                isEditScriptMode = false;
                scriptName = urlParts[3];
            }

            if (routeGroup === 'diff') {
                page = 'compare';
                isEditScriptMode = false;
                scriptName = urlParts[3];
            }
        } else {
            if (routeGroup === 'scripts') {
                scriptName = urlParts[3];
                isEditScriptMode = true;
            }

            if (urlParts[4] === 'tests') {
                isTestMode = true;
                isEditScriptMode = false;
                if (urlParts[5]) {
                    conversationName = decodeURIComponent(urlParts[5]);
                }
            }
            if (urlParts[4] === 'corpus' || urlParts[4] === 'corpuses') {
                page = 'corpus';
            }
        }
    }


    if (urlParts[0] === 'plans') {
        page = 'plans';
    }

    if (urlParts[0] === 'billing') {
        page = 'billing';
    }

    if (urlParts[0] === 'invite-friends') {
        page = 'invite-friends';
    }

    if (urlParts[0] === 'profile') {
        page = 'profile';
    }

    if (urlParts[0] === 'organization') {
        page = 'organization';
    }

    if (!page && urlParts[0] === 'projects') {
        page = 'projects';
    }

    return {
        projectName,
        scriptName,
        conversationName,
        isTestMode,
        isEditScriptMode,
        page
    };
}

export default getUrlInfo;
